<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="firf5471h1form" #form="ngForm" novalidate>
    <div class="form-panel">

      <!-- Consolidated Financial Statement -->
      @if (con_fin_stmt_flg) {

        <div class="form-row">
          <label class="form-label">Consolidated Financial Statement Amount :</label>
          <input type="text" class="form-control form-input"
                 formControlName="confinstmtamt"
                 [(ngModel)]="con_fin_stmt_amt"
                 [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-row">
          <label class="form-label">Consolidated Financial Statement Comment :</label>
          <input type="text" class="form-control form-input"
                 formControlName="confinstmtcmt"
                 [(ngModel)]="con_fin_stmt_comment"
                 [ngModelOptions]="{standalone: true}">
        </div>
      
}

      <!-- Consolidated Return -->
      @if (con_rtn_flg) {

        <div class="form-row">
          <label class="form-label">Consolidated Return Amount :</label>
          <input type="text" class="form-control form-input"
                 formControlName="conrtnamt"
                 [(ngModel)]="con_rtn_amt"
                 [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-row">
          <label class="form-label">Consolidated Return Comment :</label>
          <input type="text" class="form-control form-input"
                 formControlName="conrtncmt"
                 [(ngModel)]="con_rtn_comment"
                 [ngModelOptions]="{standalone: true}">
        </div>
      
}

      <!-- Other Adjustments -->
      @if (oth_adj_flg) {

        <div class="form-row">
          <label class="form-label">Other Adjustments Amount :</label>
          <input type="text" class="form-control form-input"
                 formControlName="othadjamt"
                 [(ngModel)]="oth_adj_amt"
                 [ngModelOptions]="{standalone: true}">
        </div>
        <div class="form-row">
          <label class="form-label">Other Adjustments Comment :</label>
          <input type="text" class="form-control form-input"
                 formControlName="othadjcmt"
                 [(ngModel)]="oth_adj_comment"
                 [ngModelOptions]="{standalone: true}">
        </div>
      
}

    </div>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button class="save-button" type="button" [disabled]="!enableButton" (click)="save()">
    @if (!enableButton) {
<i class="fa fa-spin fa-spinner"></i>
} Save
  </button>
  <button class="cancel-button" type="button" [disabled]="!enableButton" (click)="cancel()">Cancel</button>
</div>
